import { Box, Text, Button } from "../../../../../../mads";
import { Error, Close } from "../../../../../../mads/icons";
import { useI18n } from "../../../../../../shared/I18n";

import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  errorIcon: {
    marginRight: 12,
  },
  errorWrapper: {
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 16,
    paddingRight: 12,
    paddingVertical: 12,
    backgroundColor: colors.backgroundStatusCriticalWeaker,
    borderRadius: 24,
    marginHorizontal: 24,
    marginTop: 8,
    marginBottom: 8,
  },
  errorTextContainer: {
    flex: 1,
  },
  closeButton: {
    marginLeft: 8,
    padding: 0,
  },
});

export interface ErrorAlertProps {
  onDismiss?: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ onDismiss }) => {
  const { gettext } = useI18n();

  return (
    <Box sx={styles.errorWrapper}>
      <Box sx={styles.errorIcon}>
        <Error aria-hidden size="sm" fill={colors.foregroundStatusCritical} />
      </Box>
      <Box sx={styles.errorTextContainer}>
        <Text sx={{ color: "foreground", fontSize: 14 }}>
          {gettext("An error occurred. Try again later.")}
        </Text>
      </Box>
      {onDismiss && (
        <Button
          iconOnly
          sx={styles.closeButton}
          variant="tertiary"
          onPress={onDismiss}
          size="md"
          ariaLabel="Dismiss error"
          iconBefore={<Close size="sm" color={colors.foregroundStrong} aria-hidden />}
        />
      )}
    </Box>
  );
};
